import styled, { css } from 'styled-components';

export const PlayerWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    aspect-ratio: 16 / 9;
    max-width: 1280px;
    border-radius: 1.25rem;
    overflow: hidden;
    background: ${theme.colors.foreground[100]};
    box-shadow: ${theme.shadows.lg};
    margin-bottom: 1.25rem;
    cursor: pointer;
  `}
`;

export const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlayOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  transition: background 200ms ease;

  ${PlayerWrapper}:hover & {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export const PlayButton = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: transform 200ms ease;
  color: #000;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.2rem;
  }

  ${PlayerWrapper}:hover & {
    transform: scale(1.08);
  }
`;

export const IframeWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
